import { SnackbarProvider as NotistackProvider } from 'notistack'
import type { ReactNode } from 'react'

interface SnackbarProviderProps {
  children: ReactNode
}

const SnackbarProvider = ({ children }: SnackbarProviderProps) => {
  return (
    <NotistackProvider
      maxSnack={3}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'center',
      }}
      autoHideDuration={4000}
    >
      {children}
    </NotistackProvider>
  )
}

export default SnackbarProvider